/* Comic Legion V3.1 (styles in assets/cl-v31.css).
   - Search filter (All / Preorders / Back issues) shared by every search box, with matching placeholders.
   - Chat: the floating bubble is hidden; anything marked data-cl-chat opens the chat window.
   - Rewards: anything marked data-cl-rewards opens the Smile rewards panel.
   - Gold cart icon while the cart popup is open.
   - Collection and search pages: the new browser (publisher pills, Explore search, sort, Apple-style dot pager that floats
     then docks, swipe and arrow keys to flip pages). It reuses the theme's own product cards, loaded page by page. */
try { (function () {
  'use strict';
  var d = document, root = d.documentElement;
  /* Text in the page's language: window.CLT (from snippets/cl-v31-head) maps English text to French / Spanish. */
  function tr(s) { var T = window.CLT; return (T && T[s]) || s; }
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || d).querySelectorAll(s)); }
  function ready(f) { function g() { try { f(); } catch (e) { if (window.console) console.error('[Comic Legion] a site feature failed; the rest keep working', e); } } if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', g); else g(); }
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------------- Search filter ---------------- */
  var MODES = { '': tr('Search comics, publishers, creators'), 'preorders': tr('Search preorders'), 'back-issues': tr('Search back issues') };
  window.clSearchMode = '';
  /* every page starts on All */
  if (!(window.clSearchMode in MODES)) window.clSearchMode = '';
  window.clModeMatch = function (type, mode) {
    mode = mode == null ? window.clSearchMode : mode; type = String(type || '');
    if (mode === 'preorders') return /preorder|presale/i.test(type);
    if (mode === 'back-issues') return /back issue/i.test(type);
    return true;
  };
  function placeThumb(seg) {
    var on = $('[aria-checked="true"]', seg), th = $('.cl-seg__thumb', seg);
    if (!on || !th || !on.offsetWidth) return;
    th.style.width = on.offsetWidth + 'px'; th.style.transform = 'translateX(' + (on.offsetLeft - 3) + 'px)';
    requestAnimationFrame(function () { seg.classList.add('is-ready'); });
  }
  function applyMode(mode, from) {
    window.clSearchMode = mode;
    $$('.cl-seg').forEach(function (seg) {
      $$('button[data-mode]', seg).forEach(function (b) { b.setAttribute('aria-checked', b.getAttribute('data-mode') === mode ? 'true' : 'false'); });
      var hid = $('input[name="cl_f"]', seg); if (hid) { hid.value = mode; hid.disabled = !mode; }
      var form = seg.closest('form') || seg.parentElement;
      if (form) {
        form.setAttribute('data-cl-mode', mode);
        $$('input[type="search"], input[name="q"]', form).forEach(function (inp) {
          inp.placeholder = MODES[mode]; inp.setAttribute('aria-label', MODES[mode]);
          if (seg === from && inp.value.trim().length > 1) inp.dispatchEvent(new Event('input', { bubbles: true }));
        });
      }
      placeThumb(seg);
    });
  }
  window.clApplySearchMode = applyMode;
  /* The search button shows the return key only once something has been typed in its box. */
  function typed(inp) { var f = inp.closest('form') || inp.parentElement; if (f) f.classList.toggle('cl-typed', !!inp.value.trim()); }
  window.clTyped = typed;
  ['input', 'focusin', 'change'].forEach(function (ev) { d.addEventListener(ev, function (e) { var t = e.target; if (t && t.matches && t.matches('input[type="search"], input[name="q"]')) typed(t); }, true); });
  ready(function () { $$('input[type="search"], input[name="q"]').forEach(typed); });
  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.cl-seg button[data-mode]'); if (!b) return;
    e.preventDefault(); applyMode(b.getAttribute('data-mode'), b.closest('.cl-seg'));
    var form = b.closest('form'), inp = form && $('input[name="q"]', form); if (inp && !('ontouchstart' in window)) inp.focus();
  });
  ready(function () { applyMode(window.clSearchMode); });
  window.addEventListener('resize', function () { $$('.cl-seg').forEach(placeThumb); });
  /* thumbs inside panels that open later need measuring once visible */
  d.addEventListener('cl:shown', function () { $$('.cl-seg').forEach(placeThumb); });

  /* ---------------- Chat ---------------- */
  function chatEl() { return $('shopify-chat') || $('inbox-online-store-chat'); }
  /* Shopify's chat nests its button a shadow root or two deep, and rebuilds it after the chat closes, so every root is
     checked again every couple of seconds (only adds the hiding rule where it's missing). */
  function roots() {
    var out = [], c = chatEl(); if (!c || !c.shadowRoot) return out;
    (function walk(r, depth) { out.push(r); if (depth > 3) return; [].forEach.call(r.querySelectorAll('*'), function (el) { if (el.shadowRoot) walk(el.shadowRoot, depth + 1); }); })(c.shadowRoot, 0);
    return out;
  }
  function hideBubble() {
    roots().forEach(function (r) {
      if (r.getElementById && r.getElementById('cl-nobubble')) return;
      if (!r.querySelector('.activator, button[aria-label="Open chat"]')) return;
      var st = d.createElement('style'); st.id = 'cl-nobubble';
      st.textContent = '.activator, button[aria-label="Open chat"] { display: none !important; }';
      r.appendChild(st);
    });
  }
  setInterval(hideBubble, 1500); ready(hideBubble);
  /* Chat loads only when someone taps Chat (speed, 2026-11-03): Shopify Inbox's app embed is switched off in the theme
     settings, and the same chat (same settings as the embed had) is added to the page on the first tap, then opened.
     If Inbox's settings change in the Inbox app, update CHAT_CFG to match. If it can't load, Chat opens the contact page. */
  var CHAT_CFG = { settings: { invertActivatorColors: true, greetingMessage: "Welcome to Comic Legion! Send us a message if you need anything!", showFeaturedProducts: true, featuredProducts: [], horizontalPosition: "bottom_left", icon: "chat_bubble", buttonLabel: "" } };
  var chatLoading = null;
  function loadChat() {
    if (chatEl()) return Promise.resolve(true);
    if (chatLoading) return chatLoading;
    chatLoading = new Promise(function (res) {
      var data = d.createElement('script'); data.id = 'shopify-chat-app-embed-data'; data.type = 'application/json'; data.textContent = JSON.stringify(CHAT_CFG); d.body.appendChild(data);
      var st = d.createElement('style'); st.textContent = 'shopify-chat:defined:empty{display:grid}:root{--shopify-chat-bg-color:#FFFFFF;--shopify-chat-text-color:#000000;--shopify-chat-accent-bg-color:#000000;--shopify-chat-accent-text-color:#FFFFFF;--shopify-chat-activator-offset:20px;--shopify-chat-activator-font-size:16px;--shopify-chat-border-radius:16px}'; d.head.appendChild(st);
      d.body.appendChild(d.createElement('shopify-chat'));
      var sc = d.createElement('script'); sc.type = 'module'; sc.crossOrigin = 'anonymous'; sc.src = 'https://cdn.shopify.com/storefront/web-components/chat.js';
      sc.onerror = function () { res(false); }; d.head.appendChild(sc);
      var n = 0; (function wait() { if (roots().some(function (r) { return r.querySelector('button.activator, button[aria-label="Open chat"]'); })) return res(true); if (++n > 60) return res(false); setTimeout(wait, 150); })();
    });
    return chatLoading;
  }
  window.clOpenChat = function () {
    var btn = null; roots().some(function (r) { btn = r.querySelector('button.activator, button[aria-label="Open chat"]'); return !!btn; });
    if (btn) { btn.click(); return true; }
    loadChat().then(function (ok) {
      var b2 = null; roots().some(function (r) { b2 = r.querySelector('button.activator, button[aria-label="Open chat"]'); return !!b2; });
      if (ok && b2) { hideBubble(); b2.click(); return; }
      var c = chatEl(); if (ok && c) { c.setAttribute('open', ''); return; }
      window.location.href = '/pages/contact';
    });
    return true;
  };
  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-cl-chat]'); if (!a) return;
    e.preventDefault();
    var bar = $('#clFloat'); if (bar && bar.classList.contains('is-menu')) { var bg = $('.clf__burger', bar); if (bg) bg.click(); }
    setTimeout(window.clOpenChat, 60);
  });

  /* ---------------- Rewards panel (Smile) ---------------- */
  var smileAsked = false;   /* Smile "lite" mode: ask for the full tools once the loader exists; wait up to 30 s (owner 2026-11-03) */
  function smileUi(cb, n) {
    n = n || 0;
    if (window.SmileUI) return cb(window.SmileUI);
    if (!smileAsked && window.loadSmileSdk) { smileAsked = true; try { window.loadSmileSdk(); } catch (e) {} }
    if (n > 120) { window.location.href = '/pages/comic-legion-loyalty-points'; return; }
    setTimeout(function () { smileUi(cb, n + 1); }, 250);
  }
  window.clSmile = smileUi;
  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-cl-rewards]'); if (!a) return;
    e.preventDefault();
    var link = a.getAttribute('data-cl-rewards') || '';
    smileUi(function (ui) { try { ui.openPanel(link ? { deep_link: link } : undefined); } catch (err) { try { ui.openPanel(); } catch (_) {} } });
  });

  /* ---------------- Phone menu: exactly as tall as what it shows; it only scrolls when that is taller than the screen ---------------- */
  ready(function () {
    var clf = $("#clFloat"), panel = clf && $(".clf__panel", clf), views = panel && $(".clf__views", panel);
    if (!panel || !views) return;
    function fit() {
      if (!clf.classList.contains("is-menu") || innerWidth > 999) { panel.style.height = ""; return; }
      var v = $(".clf__view--sub.is-open", views) || $(".clf__view--main", views);
      var max = Math.round((window.visualViewport ? visualViewport.height : innerHeight) - 90);
      var need = 0; [].forEach.call(v.children, function (c) { if (c.offsetParent !== null || getComputedStyle(c).display !== "none") need = Math.max(need, c.offsetTop + c.offsetHeight); });
      need += parseFloat(getComputedStyle(v).paddingBottom) || 0;
      var hgt = Math.min(need, max);
      panel.style.setProperty("height", hgt + "px", "important");
      $$(".clf__view", views).forEach(function (x) { var scroll = x === v && need > max + 1; x.style.overflowY = scroll ? "auto" : "hidden"; x.style.overscrollBehavior = "contain"; x.style.touchAction = scroll ? "pan-y" : "none"; });
    }
    var mo = new MutationObserver(function () { requestAnimationFrame(fit); setTimeout(fit, 420); });
    mo.observe(clf, { attributes: true, attributeFilter: ["class"] });
    mo.observe(views, { attributes: true, subtree: true, attributeFilter: ["class"] });
    var pres = $("#clfPResults"); if (pres) new MutationObserver(function () { requestAnimationFrame(fit); }).observe(pres, { childList: true, attributes: true, attributeFilter: ["hidden"] });
    window.addEventListener("resize", fit);
  });

  /* ---------------- Gold cart icon while the cart popup is open ---------------- */
  ready(function () {
    var mc = $('#mini-cart'); if (!mc) return;
    function sync() { root.classList.toggle('cl-cart-open', mc.getAttribute('aria-hidden') === 'false'); }
    new MutationObserver(sync).observe(mc, { attributes: true, attributeFilter: ['aria-hidden'] }); sync();
  });

  /* ---------------- Account + Holdbox: instant search under the Orders header ---------------- */
  ready(function () {
    var cards = $$(".cla__order"), hb = false;
    if (!cards.length) { cards = $$(".clhb__order"); hb = true; }
    if (!cards.length) return;
    var anchor = hb ? ($(".clhb__seg") || cards[0]) : ($(".cla__h2--orders") || $(".cla__h2:not(#claInvH)") || cards[0]).nextElementSibling;
    /* The page prints the search box itself (no jump when this script arrives); older pages get one added here. */
    var box = $(".cl-osearch[data-orders]");
    if (!box) { box = d.createElement("div"); box.className = "cl-osearch"; box.setAttribute("data-orders", ""); box.innerHTML = "<input type=\"search\" placeholder=\"Search your orders: order #, comic, publisher\" aria-label=\"Search your orders\" autocomplete=\"off\" autocorrect=\"off\" spellcheck=\"false\" enterkeyhint=\"search\">"; anchor.parentNode.insertBefore(box, anchor); }
    var none = d.createElement("p"); none.className = "cl-onone"; none.hidden = true; cards[cards.length - 1].parentNode.insertBefore(none, cards[cards.length - 1].nextSibling);
    var inp = $("input", box), hay = cards.map(function (c) { return (c.textContent || "").replace(/\s+/g, " ").toLowerCase(); });
    inp.addEventListener("input", function () {
      var words = inp.value.trim().toLowerCase().replace(/#/g, "").split(/\s+/).filter(Boolean), shown = 0;
      cards.forEach(function (c, i) {
        var ok = words.every(function (w) { return hay[i].replace(/#/g, "").indexOf(w) > -1; });
        c.classList.toggle("cl-qhide", !ok); if (ok) shown++;
        if (words.length && ok && c.tagName === "DETAILS") c.open = true;
      });
      none.hidden = !words.length || shown > 0; var lg = (d.documentElement.lang || "en").slice(0, 2), qv = inp.value.trim();
      none.textContent = lg === "fr" ? "Aucune commande ne correspond à « " + qv + " »" + (hb ? "." : " sur cette page.") : lg === "es" ? "Ningún pedido coincide con “" + qv + "”" + (hb ? "." : " en esta página.") : "No orders match \u201c" + qv + "\u201d" + (hb ? "." : " on this page.");
    });
  });

  /* ---------------- Cover-colour strip on every product tile (collections, home rows, product pages, search) ---------------- */
  try { (function () {
    /* Cover-colour strip along the top of each tile: a gradient taken from the tile's own cover (a tiny 32px copy, read once
       when the tile comes into view and remembered in the browser). */
    function coverBar(card) {
      if (card.__clbar) return; card.__clbar = 1;
      var img = card.querySelector(".product-item__primary-image"); if (!img) return;
      var src = img.currentSrc || img.src; if (!src) return;
      var url = src.replace(/([?&])width=\d+/, "$1width=32"); if (url === src) url += (src.indexOf("?") > -1 ? "&" : "?") + "width=32";
      var key = "clbar:" + url.replace(/^https?:/, "");
      try { var hit = localStorage.getItem(key); if (hit) { card.style.setProperty("--cl-bar", hit); card.classList.add("cl-bar-on"); return; } } catch (e) {}
      var im = new Image(); im.crossOrigin = "anonymous";
      im.onload = function () {
        try {
          var W = 30, H = 45, N = 6, c = d.createElement("canvas"); c.width = W; c.height = H;
          var x = c.getContext("2d", { willReadFrequently: true }); x.drawImage(im, 0, 0, W, H);
          var px = x.getImageData(0, 0, W, H).data, stops = [];
          for (var k = 0; k < N; k++) {
            var r = 0, g = 0, b = 0, n = 0;
            for (var yy = 0; yy < H; yy++) for (var xx = Math.floor(k * W / N); xx < Math.floor((k + 1) * W / N); xx++) {
              var i = (yy * W + xx) * 4, R = px[i], G = px[i + 1], B = px[i + 2], mx = Math.max(R, G, B), mn = Math.min(R, G, B), l = (mx + mn) / 2, sat = (mx - mn) / 255;
              var w = sat * sat + .02; if (l < 25 || l > 235) w *= .1; r += R * w; g += G * w; b += B * w; n += w;
            }
            var m = (r + g + b) / (3 * n);
            stops.push([r / n, g / n, b / n].map(function (v) { return Math.max(0, Math.min(255, Math.round(m + (v - m) * 1.2))); }));
          }
          var css = "linear-gradient(90deg," + stops.map(function (st, i) { return "rgb(" + st.join(",") + ") " + Math.round(i * 100 / (N - 1)) + "%"; }).join(",") + ")";
          card.style.setProperty("--cl-bar", css); card.classList.add("cl-bar-on");
          try { localStorage.setItem(key, css); } catch (e) {}
        } catch (e) {}
      };
      im.src = url;
    }
    var barIO = "IntersectionObserver" in window ? new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { barIO.unobserve(e.target); coverBar(e.target); } }); }, { rootMargin: "300px 0px" }) : null;
    /* The strip follows the white card exactly: its corners are the tile corners minus the tile's (invisible) border. */
    function stripRadius(el) { var cs = getComputedStyle(el), r = parseFloat(cs.borderTopLeftRadius) || 0, bw = parseFloat(cs.borderTopWidth) || 0;
      el.style.setProperty("--cl-strip-r", Math.max(0, r - bw) + "px"); }
    var stripW = window.innerWidth;
    window.addEventListener("resize", function () { if (window.innerWidth === stripW) return; stripW = window.innerWidth; clearTimeout(stripRadius.t);
      stripRadius.t = setTimeout(function () { Array.prototype.forEach.call(d.querySelectorAll(".product-item"), function (el) { if (el.__clbarW) stripRadius(el); }); }, 150); });
    function watchBars() { Array.prototype.forEach.call(d.querySelectorAll(".product-item"), function (el) { if (el.__clbarW) return; el.__clbarW = 1; if (!el.querySelector(":scope > .cl-strip")) { var st = d.createElement("span"); st.className = "cl-strip"; st.setAttribute("aria-hidden", "true"); el.insertBefore(st, el.firstChild); } stripRadius(el); if (barIO) barIO.observe(el); else coverBar(el); }); }
    ready(function () { watchBars(); new MutationObserver(function () { clearTimeout(watchBars.t); watchBars.t = setTimeout(watchBars, 120); }).observe(d.body, { childList: true, subtree: true }); });
  })(); } catch (e) { if (window.console) console.error('[Comic Legion] a site feature failed; the rest keep working', e); }

  /* ================= Collection / search browser ================= */
  var C = window.CLB;
  if (!C) return;

  var ICON_SEARCH = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" stroke-width="2.4"/><path d="M15.5 15.5L20 20" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';
  var ICON_SORT = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 4v16M3.5 16.5L7 20l3.5-3.5M17 20V4M13.5 7.5L17 4l3.5 3.5"/></svg>';
  var ICON_L = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_R = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var PUBS = [
    { k: 'all', t: tr('All') },
    { k: 'marvel', t: 'Marvel', m: function (v) { return /^MARVEL/.test(v); } },
    { k: 'dc', t: 'DC Comics', m: function (v) { return /^DC\b/.test(v); } },
    { k: 'image', t: 'Image Comics', m: function (v) { return /^IMAGE\b/.test(v); } },
    { k: 'other', t: tr('Other Publishers'), m: function (v) { return !/^(MARVEL|DC\b|IMAGE\b)/.test(v); } }
  ];
  var TYPES = [
    { k: 'all', t: tr('All') },
    { k: 'preorders', t: tr('Preorders'), m: function (v, it) { return it.lab === 'pre-order'; } },
    { k: 'back-issues', t: tr('Back issues'), m: function (v, it) { return it.lab === 'back issue'; } }
  ];

  ready(function () {
    var sec = $('main#main > .shopify-section[id$="__main"]') || $('main#main > .shopify-section');
    if (!sec) return;
    var grid = $('.product-list--collection', sec) || $('.product-list--search', sec) || (function () { var p = $('.product-item', sec); return p && p.parentElement; })();
    if (!grid) {
      if (C.mode === 'search') return;
      return;
    }
    var host = grid.closest('.collection') || grid.closest('.layout__section') || grid.parentElement;
    var card = $(':scope > .card', host) || host;
    var dyn = grid.closest('.collection__dynamic-part') || grid;
    var sectionId = sec.id.replace(/^shopify-section-/, '');
    var perServer = $$('.product-item', grid).length || 48;
    var total = Math.max(C.count || 0, perServer);
    var serverPages = Math.max(1, Math.ceil(total / Math.max(perServer, 1)));
    /* V3.1: collections other than the comic preorders bring their own top publishers (C.pubs); pills = All + those + Other. */
    var ACR = ['DC', 'IDW', 'VIZ', 'AWA', 'TKO', 'SLG', 'BOOM!', 'IDW', 'AHOY', 'DSTLRY', 'NBM', 'IPI', 'TOKYOPOP'];
    function niceName(n) { return String(n).trim().split(/\s+/).map(function (w) { var u = w.toUpperCase(); var SP = { HARPERCOLLINS: 'HarperCollins', TOKYOPOP: 'Tokyopop', MCFARLANE: 'McFarlane', SCHOLASTIC: 'Scholastic', 'GRAPHIX': 'Graphix', 'ONI': 'Oni' }; if (SP[u]) return SP[u]; if (ACR.indexOf(u) >= 0) return u; if (u === 'LLC' || u === 'INC' || u === 'INC.') return ''; return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(); }).filter(Boolean).join(' '); }
    var DYN = null;
    if (C.pubs && C.pubs.length) {
      var up = C.pubs.map(function (p) { return String(p).trim().toUpperCase(); });
      DYN = [{ k: 'all', t: tr('All') }].concat(up.map(function (u, i) { return { k: 'p' + i, t: niceName(C.pubs[i]), m: function (v) { return v === u; } }; }))
        .concat([{ k: 'other', t: tr('Other Publishers'), m: function (v) { return up.indexOf(v) < 0; } }]);
    }
    var cats = C.mode === 'search' ? TYPES : (C.pills ? (DYN || PUBS) : null);

    host.classList.add('clb-host'); grid.classList.add('clb-grid'); root.classList.add('clb-on');

    /* ---------- state (kept in the address bar so Back returns to the same page) ---------- */
    var H = {}; location.hash.replace(/^#/, '').split('&').forEach(function (p) { var kv = p.split('='); if (kv[0]) H[kv[0]] = decodeURIComponent(kv[1] || ''); });
    var qs = new URLSearchParams(location.search);
    var S = {
      page: Math.max(1, parseInt(H.pg, 10) || 1),
      cat: H.cat || (C.mode === 'search' ? (qs.get('cl_f') || 'all') : 'all'),
      q: H.q || '',
      sort: qs.get('sort_by') || H.sort || (C.mode === 'search' ? '' : 'title-ascending')
    };
    if (!cats || !cats.some(function (c) { return c.k === S.cat; })) S.cat = 'all';

    /* ---------- items ---------- */
    var items = [], loaded = 0, loading = false;
    function wrap(el) {
      var v = (($('.product-item__vendor', el) || {}).textContent || '').trim().toUpperCase();
      var t = (($('.product-item__title', el) || {}).textContent || '').trim();
      var lab = (($('.cl-preorder-label', el) || {}).textContent || '').trim().toLowerCase();
      return { el: el, v: v, t: t.toLowerCase(), lab: lab, hay: (t + ' ' + v).toLowerCase() };
    }
    function take(nodes) { nodes.forEach(function (el) { items.push(wrap(el)); }); }
    function fetchPage(n, sort) {
      var u = new URL(location.href); u.hash = '';
      u.searchParams.set('section_id', sectionId); u.searchParams.set('page', n);
      if (sort) u.searchParams.set('sort_by', sort); else u.searchParams.delete('sort_by');
      return fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var g = $('.product-list--collection', doc) || $('.product-list--search', doc) || doc;
        return $$('.product-item', g).map(function (el) { return d.importNode(el, true); });
      });
    }
    function loadAll(sort, fresh) {
      var token = {}; loadAll.token = token;
      loading = true; showSpin(true);
      var start = fresh ? 1 : 2, pages = [];
      for (var i = start; i <= serverPages; i++) pages.push(i);
      var results = {}, next = 0;
      function worker() {
        if (next >= pages.length || loadAll.token !== token) return Promise.resolve();
        var n = pages[next++];
        return fetchPage(n, sort).then(function (nodes) { results[n] = nodes; }).catch(function () { results[n] = []; }).then(worker);
      }
      return Promise.all([worker(), worker(), worker()]).then(function () {
        if (loadAll.token !== token) return;
        if (fresh) items = [];
        pages.forEach(function (n) { take(results[n] || []); });
        loaded = items.length; loading = false; showSpin(false);
        countPills(); render(0, true);
      });
    }

    /* ---------- control bar ---------- */
    var bar = d.createElement('div'); bar.className = 'clb-bar';
    var sentinel = d.createElement('div'); sentinel.className = 'clb-sentinel';
    var pillsHTML = '';
    if (cats) {
      pillsHTML = '<div class="clb-pills" role="group" aria-label="' + tr(C.mode === 'search' ? 'Show' : 'Publisher') + '"><span class="clb-pills__thumb" aria-hidden="true"></span>' +
        cats.map(function (c) { return '<button type="button" data-cat="' + c.k + '" aria-pressed="' + (c.k === S.cat) + '">' + esc(c.t) + '<span class="clb-pills__n"></span></button>'; }).join('') + '</div>';
    }
    if (cats) {
      pillsHTML += '<label class="clb-pub"><span class="clb-pub__k">' + tr(C.mode === 'search' ? 'Show' : 'Publisher') + '</span><span class="clb-pub__v"></span>' +
        '<svg viewBox="0 0 10 6" aria-hidden="true"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '<select aria-label="' + tr(C.mode === 'search' ? 'Show' : 'Publisher') + '">' + cats.map(function (c) { return '<option value="' + c.k + '"' + (c.k === S.cat ? ' selected' : '') + '>' + esc(c.t) + '</option>'; }).join('') + '</select></label>';
    }
    var sortOpts = C.mode === 'search'
      ? [['', tr('Best match')], ['created-descending', tr('Newest')], ['price-ascending', tr('Price: low to high')], ['price-descending', tr('Price: high to low')]]
      : [['title-ascending', tr('A to Z')], ['title-descending', tr('Z to A')], ['created-descending', tr('Newest')], ['price-ascending', tr('Price: low to high')], ['price-descending', tr('Price: high to low')], ['manual', tr('Featured')]];
    bar.innerHTML = '<div class="clb-bar__in">' + (pillsHTML || '<div class="clb-info"></div>') +
      (C.mode === 'search' ? '' : '<button type="button" class="clb-explore" aria-label="' + esc(C.explore) + '">' + ICON_SEARCH + '<span>' + esc(C.explore) + '</span></button>') +
      '<label class="clb-find">' + ICON_SEARCH + '<input type="search" enterkeyhint="search" autocomplete="off" autocorrect="off" spellcheck="false" placeholder="' + esc(C.placeholder) + '" aria-label="' + esc(C.placeholder) + '"><span class="clb-find__n"></span><button type="button" class="clb-find__x">Done</button></label>' +
      '<label class="clb-sort" title="' + tr('Sort') + '">' + ICON_SORT + '<span class="clb-sort__t"></span><select aria-label="' + tr('Sort') + '">' +
      sortOpts.map(function (o) { return '<option value="' + o[0] + '"' + (o[0] === S.sort ? ' selected' : '') + '>' + o[1] + '</option>'; }).join('') + '</select></label></div>';
    dyn.parentNode.insertBefore(sentinel, dyn); dyn.parentNode.insertBefore(bar, dyn);
    /* The collection banner joins the same column as the panel and the tiles, so all three share the same edges and spacing. */
    /* r49: the banner stays in its own section (moving it into the products column made the page jump on load). CSS gives it
       the same width and spacing as the column, from the very first frame. */
    /* tell the banner it is in its final place (its covers wait for this, so they rise once, not twice) */
    try { d.dispatchEvent(new Event("clch:placed")); } catch (e) {}
    if (C.mode === 'search') { var tl = $('.clb-sort__t', bar); }
    var sortSel = $('.clb-sort select', bar), sortT = $('.clb-sort__t', bar);
    function sortLabel() { sortT.textContent = sortSel.options[sortSel.selectedIndex].text; }
    sortLabel();
    var pubSel = $('.clb-pub select', bar), pubV = $('.clb-pub__v', bar);
    function pubLabel() { if (pubSel) { pubSel.value = S.cat; pubV.textContent = pubSel.options[pubSel.selectedIndex].text; } }
    pubLabel();
    var pills = $('.clb-pills', bar), findInp = $('.clb-find input', bar), findN = $('.clb-find__n', bar), info = $('.clb-info', bar);
    if (C.pubs && pills) pills.classList.add('is-wait');
    /* r48: the publisher outline re-measures whenever the pill row changes size (Explore growing, the bar sticking, fonts,
       window resizes), so it always sits exactly on the chosen publisher. */
    if (pills && window.ResizeObserver) { var plRO = new ResizeObserver(function () { placePill(true); }); plRO.observe(pills); [].forEach.call(pills.querySelectorAll('button'), function (b) { plRO.observe(b); }); }

    /* instant = re-measuring because the layout moved (Explore growing, resizes): the outline sticks to its pill with no slide.
       Only picking a publisher animates it. */
    function placePill(instant) {
      if (!pills) return;
      var on = $('button[aria-pressed="true"]', pills), th = $('.clb-pills__thumb', pills);
      if (!on) return;
      if (instant === true) th.style.setProperty('transition', 'none', 'important');
      th.style.width = on.offsetWidth + 'px'; th.style.transform = 'translateX(' + on.offsetLeft + 'px)';
      if (instant === true) { void th.offsetWidth; th.style.removeProperty('transition'); }
      requestAnimationFrame(function () { pills.classList.add('is-ready'); });
      if (on.offsetLeft < pills.scrollLeft || on.offsetLeft + on.offsetWidth > pills.scrollLeft + pills.clientWidth) pills.scrollTo({ left: on.offsetLeft - 20, behavior: 'smooth' });
    }
    var autoDone = false;
    function autoPubs() {
      if (!C.pubs || autoDone || loading || !pills || !items.length) return;
      autoDone = true; pills.classList.remove('is-wait');
      var cnt = {};
      items.forEach(function (it) { if (it.v) cnt[it.v] = (cnt[it.v] || 0) + 1; });
      var top = Object.keys(cnt).sort(function (a, b) { return cnt[b] - cnt[a]; }).slice(0, 3);
      if (top.length < 2) return;
      cats = [{ k: 'all', t: tr('All') }].concat(top.map(function (u, i) { return { k: 'p' + i, t: niceName(u), m: function (v) { return v === u; } }; }))
        .concat([{ k: 'other', t: tr('Other Publishers'), m: function (v) { return top.indexOf(v) < 0; } }]);
      if (!cats.some(function (c) { return c.k === S.cat; })) S.cat = 'all';
      var th = $('.clb-pills__thumb', pills);
      pills.innerHTML = ''; pills.appendChild(th);
      cats.forEach(function (c) { var b = d.createElement('button'); b.type = 'button'; b.setAttribute('data-cat', c.k); b.setAttribute('aria-pressed', c.k === S.cat ? 'true' : 'false'); b.innerHTML = esc(c.t) + '<span class="clb-pills__n"></span>'; pills.appendChild(b); });
      if (pubSel) pubSel.innerHTML = cats.map(function (c) { return '<option value="' + c.k + '"' + (c.k === S.cat ? ' selected' : '') + '>' + esc(c.t) + '</option>'; }).join('');
    }
    function countPills() {
      autoPubs();
      if (!pills) return;
      $$('button[data-cat]', pills).forEach(function (b) {
        var c = cats.filter(function (x) { return x.k === b.getAttribute('data-cat'); })[0], n = c.m ? items.filter(function (it) { return c.m(it.v, it); }).length : items.length;
        $('.clb-pills__n', b).textContent = loading ? '' : n;
        if (pubSel) { var o = pubSel.querySelector('option[value="' + c.k + '"]'); if (o) o.textContent = c.t + (loading ? '' : ' (' + n + ')'); }
      });
      placePill(); pubLabel();
    }
    if (pills) pills.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-cat]'); if (!b) return;
      S.cat = b.getAttribute('data-cat');
      $$('button[data-cat]', pills).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      placePill(); pubLabel(); S.page = 1; render(0, false, 'filter');
    });
    if (pubSel) pubSel.addEventListener('change', function () {
      S.cat = pubSel.value; pubLabel();
      if (pills) $$('button[data-cat]', pills).forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-cat') === S.cat ? 'true' : 'false'); });
      placePill(); S.page = 1; render(0, false, 'filter');
    });
    var explore = $('.clb-explore', bar);
    function openFind() { bar.classList.add('is-finding'); setTimeout(function () { findInp.focus(); }, 30); }
    function closeFind() { bar.classList.remove('is-finding'); if (S.q) { S.q = ''; findInp.value = ''; S.page = 1; render(0, false, 'filter'); } setTimeout(placePill, 30); }
    if (explore) explore.addEventListener('click', openFind);
    $('.clb-find__x', bar).addEventListener('click', function (e) { e.preventDefault(); closeFind(); });
    ['focus', 'blur'].forEach(function (ev) { findInp.addEventListener(ev, function () { setTimeout(function () { placePill(true); }, 30); setTimeout(function () { placePill(true); }, 380); }); });
    var ft;
    findInp.addEventListener('input', function () { clearTimeout(ft); ft = setTimeout(function () { S.q = findInp.value.trim().toLowerCase(); S.page = 1; render(0, false, 'filter'); }, 90); });
    findInp.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeFind(); if (e.key === 'Enter') { e.preventDefault(); findInp.blur(); } });
    /* r39: on tablets and desktop the find field is always open in place of the "Explore" button (placeholder = the Explore label). */
    if (explore) { bar.classList.add('clb-bar--live'); findInp.placeholder = C.explore; findInp.setAttribute('aria-label', C.explore); }
    function live() { return explore && window.matchMedia('(min-width: 641px)').matches; }
    if (S.q) { findInp.value = S.q; if (!live()) bar.classList.add('is-finding'); }
    sortSel.addEventListener('change', function () {
      S.sort = sortSel.value; sortLabel(); S.page = 1;
      loadAll(S.sort, true);
    });

    /* 20. bar sticks under the menu; a little gooey pull when it lifts off / settles (checked on scroll, so fast jumps count too) */
    var stuck = false;
    function barState() {
      var top = parseInt(getComputedStyle(host).getPropertyValue('--clb-top'), 10) || 78;
      var r = sentinel.getBoundingClientRect(), hr = host.getBoundingClientRect();
      var s = r.top < top && hr.bottom > top + 60;
      if (s === stuck) return; stuck = s; bar.classList.toggle('is-stuck', s); document.documentElement.classList.toggle('clb-stacked', s);
      if (reduce.matches) return;
      bar.classList.remove('is-peel', 'is-land'); void bar.offsetWidth; bar.classList.add(s ? 'is-peel' : 'is-land');
    }

    /* ---------- pager ---------- */
    var dock = d.createElement('div'); dock.className = 'clb-dock';
    dock.innerHTML = '<nav class="clb-pager" aria-label="' + tr('Pages') + '">' +
      '<button type="button" class="clb-pg-btn clb-prev" aria-label="' + tr('Previous page') + '">' + ICON_L + '</button>' +
      '<div class="clb-dots" role="slider" tabindex="0" aria-label="' + tr('Page') + '" aria-valuemin="1"><div class="clb-dots__track"></div></div>' +
      '<button type="button" class="clb-pg-btn clb-next" aria-label="' + tr('Next page') + '">' + ICON_R + '</button>' +
      '<button type="button" class="clb-pg-label" aria-haspopup="listbox" aria-expanded="false"></button>' +
      '<div class="clb-pgmenu" role="listbox" aria-label="' + tr('Go to page') + '" hidden></div>' +
      '<span class="clb-bubble" aria-hidden="true"></span>' +
      '</nav>';
    var dockSentinel = d.createElement('div'); dockSentinel.style.height = '1px';
    dyn.parentNode.insertBefore(dock, dyn.nextSibling); dock.parentNode.insertBefore(dockSentinel, dock.nextSibling);
    var pager = $('.clb-pager', dock), dots = $('.clb-dots', dock), track = $('.clb-dots__track', dock), label = $('.clb-pg-label', dock),
      prevB = $('.clb-prev', dock), nextB = $('.clb-next', dock), bubble = $('.clb-bubble', dock);
    var spin = null;
    function showSpin(on) {
      if (on && !spin) { spin = d.createElement('span'); spin.className = 'clb-loading'; spin.setAttribute('aria-hidden', 'true'); pager.appendChild(spin); }
      if (!on && spin) { spin.remove(); spin = null; }
    }

    /* docked vs floating */
    var docked = null;
    function dockState() {
      var v = dockSentinel.getBoundingClientRect().top < innerHeight - 2;
      if (v === docked) return; var first = docked === null; docked = v; dock.classList.toggle('is-docked', v);
      if (first || reduce.matches) return;
      dock.classList.remove('is-peel', 'is-land'); void dock.offsetWidth; dock.classList.add(v ? 'is-land' : 'is-peel');
    }
    var tick = false;
    /* 30. Hold on lock: when the collection panel bounces into place under the menu, the products hold still with it for a
       short stretch (native sticky, so it is smooth on phones), then scroll on under the menu bars as normal. A spacer after the
       grid gives it that stretch; it is never seen, because the grid slides into it while holding. */
    var hold = d.createElement("div"); hold.className = "clb-hold"; hold.setAttribute("aria-hidden", "true"); grid.insertAdjacentElement("afterend", hold);
    function barH() { host.style.setProperty("--clb-barh", bar.offsetHeight + "px"); }
    barH(); window.addEventListener("resize", barH);
    function onScroll() { if (tick) return; tick = true; requestAnimationFrame(function () { tick = false; barState(); dockState(); }); }
    window.addEventListener('scroll', onScroll, { passive: true }); window.addEventListener('resize', onScroll);
    /* 27. never covered: lift above any banner pinned to the bottom of the screen (cookie notice etc.) */
    function lift() {
      var h = 0;
      $$('#shopify-pc__banner, .shopify-pc__banner__dialog, .privacy-banner, .cookie-bar, [class*="cookie-banner"], #PBarNextFrameWrapper').forEach(function (el) {
        var r = el.getBoundingClientRect(), s = getComputedStyle(el);
        if (s.display === 'none' || s.visibility === 'hidden' || !r.height || r.top >= innerHeight || r.bottom < innerHeight - 4) return;
        h = Math.max(h, innerHeight - r.top);
      });
      host.style.setProperty('--clb-lift', Math.min(h, innerHeight * .5) + 'px');
    }
    lift(); setInterval(lift, 1500); window.addEventListener('resize', lift);

    var SLOT = 16;
    function slots() { return parseInt(getComputedStyle(dots).getPropertyValue('--clb-slots'), 10) || 7; }
    /* Full rows on every page: desktop shows 5 per row, so 50 (10 rows); tablets and phones keep the standard 48. */
    function perPage() { return window.matchMedia('(min-width: 1000px)').matches ? 50 : 48; }
    var view = [], pages = 1, pp = perPage();
    function filtered() {
      var cat = cats && cats.filter(function (c) { return c.k === S.cat; })[0];
      var words = S.q ? S.q.split(/\s+/).filter(Boolean) : [];
      return items.filter(function (it) {
        if (cat && cat.m && !cat.m(it.v, it)) return false;
        for (var i = 0; i < words.length; i++) if (it.hay.indexOf(words[i]) < 0) return false;
        return true;
      });
    }
    function buildDots() {
      var html = ''; for (var i = 1; i <= pages; i++) html += '<span class="clb-dot" data-p="' + i + '"><i></i></span>';
      track.innerHTML = html; track.dataset.n = pages;
    }
    function paintDots(p) {
      var n = slots(), vis = Math.min(n, pages);
      dots.style.width = (vis * SLOT) + 'px';
      var start = Math.max(0, Math.min(p - 1 - Math.floor(n / 2), pages - n)); if (pages <= n) start = 0;
      track.style.transform = 'translateX(' + (-start * SLOT) + 'px)';
      $$('.clb-dot', track).forEach(function (el, i) {
        el.classList.toggle('is-cur', i === p - 1);
        var pos = i - start, edge = pages > n ? Math.min(pos, n - 1 - pos) : 9;
        el.classList.toggle('is-s1', edge === 1 && ((pos === 1 && start > 0) || (pos === n - 2 && start + n < pages)));
        el.classList.toggle('is-s2', edge === 0 && ((pos === 0 && start > 0) || (pos === n - 1 && start + n < pages)));
      });
      dots.setAttribute('aria-valuemax', pages); dots.setAttribute('aria-valuenow', p); dots.setAttribute('aria-valuetext', tr('Page') + ' ' + p + ' ' + tr('of') + ' ' + pages);
    }
    function saveHash() {
      var h = [];
      if (S.page > 1) h.push('pg=' + S.page);
      if (S.cat !== 'all' && C.mode !== 'search') h.push('cat=' + S.cat);
      if (S.q) h.push('q=' + encodeURIComponent(S.q));
      if (S.sort && S.sort !== (C.mode === 'search' ? '' : 'title-ascending')) h.push('sort=' + encodeURIComponent(S.sort));
      try { history.replaceState(history.state, '', location.pathname + location.search + (h.length ? '#' + h.join('&') : '')); } catch (e) {}
    }
    /* draw the current page. dir: +1/-1 slide in, 'filter' fade, 0 none */
    function render(dir, keepPage, how) {
      view = filtered(); pp = perPage();
      var expect = (S.cat === 'all' && !S.q) ? Math.max(view.length, loading ? total : 0) : view.length;
      pages = Math.max(1, Math.ceil(expect / pp));
      if (S.page > pages) S.page = pages;
      var start = (S.page - 1) * pp, slice = view.slice(start, start + pp);
      var frag = d.createDocumentFragment();
      slice.forEach(function (it) { frag.appendChild(it.el); });
      if (!slice.length) {
        var em = d.createElement('div'); em.className = 'clb-empty';
        em.innerHTML = loading ? '<b>' + tr('Loading…') + '</b>' : (S.q ? '<b>' + tr('No matches for') + ' “' + esc(S.q) + '”</b>' + tr('Try another title, publisher or issue number.') : '<b>' + tr('Nothing here yet') + '</b>' + tr('Check back after the next FOC update.'));
        frag.appendChild(em);
      }
      grid.replaceChildren ? grid.replaceChildren(frag) : (grid.innerHTML = '', grid.appendChild(frag));
      grid.classList.remove('is-in-next', 'is-in-prev', 'is-filtering'); void grid.offsetWidth;
      if (!reduce.matches) { if (dir > 0) grid.classList.add('is-in-next'); else if (dir < 0) grid.classList.add('is-in-prev'); else if (how === 'filter') grid.classList.add('is-filtering'); }
      if (track.dataset.n != pages) buildDots();
      paintDots(S.page);
      prevB.disabled = S.page <= 1; nextB.disabled = S.page >= pages;
      label.innerHTML = '<span class="clb-pg-word">' + tr('Page') + ' </span><b>' + S.page + '</b> ' + tr('of') + ' ' + pages + '<svg viewBox="0 0 10 6" aria-hidden="true"><path d="M1 5l4-4 4 4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      label.setAttribute('aria-label', tr('Page') + ' ' + S.page + ' ' + tr('of') + ' ' + pages + '. ' + tr('Choose a page'));
      pager.hidden = pages <= 1 && !loading;
      findN.textContent = S.q ? view.length + ' ' + tr(view.length === 1 ? 'match' : 'matches') : '';
      if (info) info.innerHTML = '<b>' + (loading ? total : view.length) + '</b> ' + tr((loading ? total : view.length) === 1 ? 'item' : 'items');
      saveHash();
      if (dir || how === 'filter') setTimeout(land, 30);
    }
    /* After a page change: if the new page is too short for where you are (say a last page with a few books), glide up so you
       land on its products instead of the footer. Otherwise stay put (no jumping to the top). */
    function land() {
      var r = grid.getBoundingClientRect();
      if (r.bottom > innerHeight * 0.7 || r.top > 0) return;
      var top = parseInt(getComputedStyle(host).getPropertyValue("--clb-top"), 10) || 78;
      var y = r.top + scrollY - top - bar.offsetHeight - 14;
      window.scrollTo({ top: Math.max(0, y), behavior: reduce.matches ? "auto" : "smooth" });
    }
    function toTop(smooth) {
      var top = card.getBoundingClientRect().top + scrollY - (parseInt(getComputedStyle(host).getPropertyValue('--clb-top'), 10) || 78) - 4;
      if (scrollY > top + 4) window.scrollTo({ top: top, behavior: smooth === false || reduce.matches ? 'auto' : 'smooth' });
    }
    function go(p, opts) {
      opts = opts || {};
      p = Math.max(1, Math.min(pages, p)); if (p === S.page) return;
      var dir = p > S.page ? 1 : -1; S.page = p; render(opts.quiet ? 0 : dir); if (opts.quiet) setTimeout(land, 30);

    }
    prevB.addEventListener('click', function () { go(S.page - 1); });
    nextB.addEventListener('click', function () { go(S.page + 1); });

    /* scrub along the dots (whole width = every page) */
    var scrub = null;
    function pageAt(x) { var r = dots.getBoundingClientRect(); var f = Math.max(0, Math.min(1, (x - r.left) / r.width)); return Math.round(f * (pages - 1)) + 1; }
    dots.addEventListener('pointerdown', function (e) {
      if (pages <= 1) return;
      scrub = { id: e.pointerId, x: e.clientX, moved: false, from: S.page };
      try { dots.setPointerCapture(e.pointerId); } catch (_) {}
      dots.classList.add('is-scrub');
    });
    dots.addEventListener('pointermove', function (e) {
      if (!scrub || e.pointerId !== scrub.id) return;
      if (!scrub.moved && Math.abs(e.clientX - scrub.x) < 4) return;
      scrub.moved = true;
      var p = pageAt(e.clientX);
      bubble.textContent = tr('Page') + ' ' + p; bubble.classList.add('is-on');
      if (p !== S.page) { S.page = p; render(0); }
    });
    function endScrub(e) {
      if (!scrub || (e && e.pointerId !== scrub.id)) return;
      var s = scrub; scrub = null; dots.classList.remove('is-scrub'); bubble.classList.remove('is-on');
      if (!s.moved) { var t = e && d.elementFromPoint(e.clientX, e.clientY), dot = t && t.closest && t.closest('.clb-dot'); if (dot) go(+dot.getAttribute('data-p')); else go(pageAt(e.clientX)); return; }
      /* the page is already showing from the drag: don't redraw or slide it in again on release (that was the flicker) */
      if (S.page !== s.from) setTimeout(land, 30);
    }
    dots.addEventListener('pointerup', endScrub); dots.addEventListener('pointercancel', endScrub);
    dots.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { e.preventDefault(); go(S.page + 1); }
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { e.preventDefault(); go(S.page - 1); }
      else if (e.key === 'Home') { e.preventDefault(); go(1); } else if (e.key === 'End') { e.preventDefault(); go(pages); }
    });

    /* mouse wheel / trackpad over the pager scrubs page to page */
    /* "Page 3 of 16" opens a drop-down list of every page (opens upward, current page ticked and scrolled into view) */
    var pgMenu = $('.clb-pgmenu', dock);
    function closeMenu() { pgMenu.hidden = true; label.setAttribute('aria-expanded', 'false'); }
    function openMenu() {
      var html = '';
      for (var i = 1; i <= pages; i++) {
        var a = (i - 1) * pp + 1, b = Math.min(i * pp, view.length);
        html += '<button type="button" role="option" data-pg="' + i + '" aria-selected="' + (i === S.page) + '"><span>' + tr('Page') + ' ' + i + '</span>' +
          (i === S.page ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>' : '') + '</button>';
      }
      pgMenu.innerHTML = html; pgMenu.hidden = false; label.setAttribute('aria-expanded', 'true');
      var cur = pgMenu.querySelector('[aria-selected="true"]'); if (cur) { pgMenu.scrollTop = cur.offsetTop - pgMenu.clientHeight / 2 + cur.offsetHeight / 2; cur.focus({ preventScroll: true }); }
    }
    label.addEventListener('click', function (e) { e.stopPropagation(); if (pgMenu.hidden) openMenu(); else closeMenu(); });
    pgMenu.addEventListener('click', function (e) { var b = e.target.closest('[data-pg]'); if (!b) return; e.stopPropagation(); closeMenu(); go(+b.getAttribute('data-pg')); });
    pgMenu.addEventListener('keydown', function (e) {
      var it = [].slice.call(pgMenu.querySelectorAll('[data-pg]')), i = it.indexOf(d.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (it[i + 1] || it[i]).focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); (it[i - 1] || it[i]).focus(); }
      else if (e.key === 'Escape') { closeMenu(); label.focus(); }
    });
    d.addEventListener('click', function (e) { if (!pgMenu.hidden && !pgMenu.contains(e.target)) closeMenu(); });
    window.addEventListener('scroll', function () { if (!pgMenu.hidden && !pgMenu.matches(':hover')) closeMenu(); }, { passive: true });
    var wAcc = 0, wLast = 0, wHide;
    pager.addEventListener('wheel', function (e) {
      if (pages <= 1 || pgMenu.contains(e.target)) return;
      e.preventDefault();
      wAcc += Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
      var now = Date.now();
      if (Math.abs(wAcc) >= 40 && now - wLast > 90) {
        var dir = wAcc > 0 ? 1 : -1; wAcc = 0; wLast = now;
        if ((dir > 0 && S.page < pages) || (dir < 0 && S.page > 1)) { S.page += dir; render(dir); bubble.textContent = tr('Page') + ' ' + S.page; bubble.classList.add('is-on'); }
        clearTimeout(wHide); wHide = setTimeout(function () { bubble.classList.remove('is-on'); }, 700);
      }
    }, { passive: false });

    /* desktop: arrow keys flip pages while the collection is on screen */
    d.addEventListener('keydown', function (e) {
      if (e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var a = d.activeElement; if (a && (/^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) || a.isContentEditable || a === dots)) return;
      var r = host.getBoundingClientRect(); if (r.bottom < 120 || r.top > innerHeight - 120) return;
      e.preventDefault(); go(S.page + (e.key === 'ArrowRight' ? 1 : -1));
    });

    /* phones: swipe the grid left/right to flip; it follows the finger */
    var sw = null, swallow = false;
    var swipeArea = card;
    swipeArea.style.touchAction = 'pan-y';
    swipeArea.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1 || pages <= 1 || (e.target.closest && e.target.closest('.clb-bar, .clb-dock, input, select, textarea'))) { sw = null; return; }
      sw = { x: e.touches[0].clientX, y: e.touches[0].clientY, dx: 0, lock: null };
    }, { passive: true });
    swipeArea.addEventListener('touchmove', function (e) {
      if (!sw) return;
      var dx = e.touches[0].clientX - sw.x, dy = e.touches[0].clientY - sw.y;
      if (sw.lock === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) sw.lock = Math.abs(dx) > Math.abs(dy) * 1.2 ? 'x' : 'y';
      if (sw.lock !== 'x') return;
      sw.dx = dx;
      var edge = (dx > 0 && S.page <= 1) || (dx < 0 && S.page >= pages);
      grid.style.transition = 'none'; grid.style.transform = 'translateX(' + (edge ? dx * .25 : dx * .9) + 'px)'; grid.style.opacity = String(1 - Math.min(Math.abs(dx) / 900, .25));
    }, { passive: true });
    function endSwipe() {
      if (!sw) return; var s = sw; sw = null;
      if (s.lock !== 'x') return;
      swallow = Math.abs(s.dx) > 10; setTimeout(function () { swallow = false; }, 350);
      var goTo = s.dx < -55 && S.page < pages ? 1 : s.dx > 55 && S.page > 1 ? -1 : 0;
      grid.style.transition = 'transform .28s cubic-bezier(.2,.8,.2,1), opacity .2s ease';
      grid.style.transform = ''; grid.style.opacity = '';
      setTimeout(function () { grid.style.transition = ''; }, 300);
      if (goTo) go(S.page + goTo);
    }
    swipeArea.addEventListener('touchend', endSwipe); swipeArea.addEventListener('touchcancel', endSwipe);
    swipeArea.addEventListener('click', function (e) { if (swallow) { e.preventDefault(); e.stopPropagation(); } }, true);


    /* Only a real width change redraws the grid. On phones, Safari's toolbar sliding in and out changes the height as you
       scroll; redrawing then made the page jump, so height-only changes are ignored. */
    var rt, lastW = innerWidth; window.addEventListener('resize', function () {
      clearTimeout(rt); rt = setTimeout(function () {
        if (innerWidth === lastW) return; lastW = innerWidth;
        var first = (S.page - 1) * pp; var np = perPage();
        if (np !== pp) { S.page = Math.floor(first / np) + 1; }
        render(0); placePill();
      }, 150);
    });


    /* start: page one is already on the page; the rest load in the background */
    take($$('.product-item', grid)); loaded = items.length;
    var serverSort = qs.get('sort_by') || C.defSort || '';
    if (S.sort && S.sort !== serverSort) { loadAll(S.sort, true); }
    else if (serverPages > 1) { loadAll(S.sort, false); }
    render(0, true);
    countPills(); barState(); dockState();
    setTimeout(placePill, 300); window.addEventListener('load', placePill);
  });
})(); } catch (e) { if (window.console) console.error('[Comic Legion] a site feature failed; the rest keep working', e); }

/* Comic Legion r33: our own "Buy with Shop" button on product pages, styled like Add to cart (light Shop-purple inside,
   purple outline, official "shop" logo). Shopify's own Shop button can't be restyled, so it is hidden and ours takes its
   place. Tapping it opens Shop Pay checkout with ONLY this item (same as Shopify's button), keeping the quantity and the
   item's details (e.g. "Est. release"), in the shopper's language. */
try { (function () {
  var LOGO = '<svg class="cl-shopbtn__logo" viewBox="5.4 6.6 26.6 10.8" aria-hidden="true"><path fill="currentColor" d="M9.35 11.368c-1.017-.223-1.47-.31-1.47-.705 0-.372.306-.558.92-.558.54 0 .934.238 1.225.704a.079.079 0 00.104.03l1.146-.584a.082.082 0 00.032-.114c-.475-.831-1.353-1.286-2.51-1.286-1.52 0-2.464.755-2.464 1.956 0 1.275 1.15 1.597 2.17 1.82 1.02.222 1.474.31 1.474.705 0 .396-.332.582-.993.582-.612 0-1.065-.282-1.34-.83a.08.08 0 00-.107-.035l-1.143.57a.083.083 0 00-.036.111c.454.92 1.384 1.437 2.627 1.437 1.583 0 2.539-.742 2.539-1.98s-1.155-1.598-2.173-1.82v-.003zM15.49 8.855c-.65 0-1.224.232-1.636.646a.04.04 0 01-.069-.03v-2.64a.08.08 0 00-.08-.081H12.27a.08.08 0 00-.08.082v8.194a.08.08 0 00.08.082h1.433a.08.08 0 00.081-.082v-3.594c0-.695.528-1.227 1.239-1.227.71 0 1.226.521 1.226 1.227v3.594a.08.08 0 00.081.082h1.433a.08.08 0 00.081-.082v-3.594c0-1.51-.981-2.577-2.355-2.577zM20.753 8.62c-.778 0-1.507.24-2.03.588a.082.082 0 00-.027.109l.632 1.088a.08.08 0 00.11.03 2.5 2.5 0 011.318-.366c1.25 0 2.17.891 2.17 2.068 0 1.003-.736 1.745-1.669 1.745-.76 0-1.288-.446-1.288-1.077 0-.361.152-.657.548-.866a.08.08 0 00.032-.113l-.596-1.018a.08.08 0 00-.098-.035c-.799.299-1.359 1.018-1.359 1.984 0 1.46 1.152 2.55 2.76 2.55 1.877 0 3.227-1.313 3.227-3.195 0-2.018-1.57-3.492-3.73-3.492zM28.675 8.843c-.724 0-1.373.27-1.845.746-.026.027-.069.007-.069-.029v-.572a.08.08 0 00-.08-.082h-1.397a.08.08 0 00-.08.082v8.182a.08.08 0 00.08.081h1.433a.08.08 0 00.081-.081v-2.683c0-.036.043-.054.069-.03a2.6 2.6 0 001.808.7c1.682 0 2.993-1.373 2.993-3.157s-1.313-3.157-2.993-3.157zm-.271 4.929c-.956 0-1.681-.768-1.681-1.783s.723-1.783 1.681-1.783c.958 0 1.68.755 1.68 1.783 0 1.027-.713 1.783-1.681 1.783h.001z"/></svg>';
  var lg = (document.documentElement.lang || 'en').slice(0, 2);
  var WORD = lg === 'fr' ? 'Acheter avec' : lg === 'es' ? 'Comprar con' : 'Buy with';
  function b64(s) { return btoa(unescape(encodeURIComponent(s))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); }
  function url(form) {
    var fd = new FormData(form), id = fd.get('id'), q = Math.max(1, parseInt(fd.get('quantity'), 10) || 1), props = {}, n = 0;
    fd.forEach(function (v, k) { var m = /^properties\[(.+)\]$/.exec(k); if (m && v !== '') { props[m[1]] = String(v); n++; } });
    var u = '/cart/' + id + ':' + q + '?payment=shop_pay';
    if (lg !== 'en') u += '&locale=' + lg;
    if (n) u += '&properties=' + b64(JSON.stringify(props));
    return u;
  }
  function add() {
    [].forEach.call(document.querySelectorAll('.product-form__payment-container'), function (box) {
      if (box.querySelector('.cl-shopbtn') || !box.querySelector('.shopify-payment-button')) return;
      var form = box.closest('form'); if (!form) return;
      var a = document.createElement('a'); a.className = 'cl-shopbtn'; a.href = '#'; a.setAttribute('role', 'button');
      a.setAttribute('aria-label', WORD + ' Shop'); a.innerHTML = '<span>' + WORD + '</span>' + LOGO;
      /* Shopify's Shop Pay link replaces the cart, so the books already in it are set aside first (kept in this browser) and
         put back on the next store page — paid or not (same as the cart's "Check out FOC only"). */
      a.addEventListener('click', function (e) {
        e.preventDefault(); if (a.classList.contains('is-busy')) return; a.classList.add('is-busy');
        var go = url(form), root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
          var items = (c.items || []).map(function (i) { var p = i.properties; if (!p || typeof p !== 'object' || Array.isArray(p)) p = {}; return { id: i.variant_id, quantity: i.quantity, properties: p }; });
          if (items.length) localStorage.setItem('clAside', JSON.stringify({ t: Date.now(), items: items }));
        }).catch(function () {}).then(function () { window.location.href = go; });
      });
      var sp = box.querySelector('.shopify-payment-button'); sp.parentNode.insertBefore(a, sp); box.classList.add('cl-has-shopbtn');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', add); else add();
  document.addEventListener('shopify:section:load', add);
})(); } catch (e) { if (window.console) console.error('[Comic Legion] a site feature failed; the rest keep working', e); }

/* r34: instant search results load sharp covers (the theme asks for tiny 120px thumbnails). */
try { (function () {
  function sharpen(root) {
    [].forEach.call(root.querySelectorAll('.search-bar__image-container img'), function (im) {
      if (im.__clSharp) return; im.__clSharp = 1;
      var s = im.getAttribute('src') || ''; if (/_120x120\./.test(s)) im.setAttribute('src', s.replace('_120x120.', '_240x.'));
    });
  }
  var mo = new MutationObserver(function (ms) { ms.forEach(function (m) { if (m.target.closest && m.target.closest('.search-bar__results')) sharpen(m.target.closest('.search-bar__results')); }); });
  function go() { mo.observe(document.body, { childList: true, subtree: true }); }
  if (document.body) go(); else document.addEventListener('DOMContentLoaded', go);
})(); } catch (e) { if (window.console) console.error('[Comic Legion] a site feature failed; the rest keep working', e); }

/* r37: Spotlight header search (desktop). The All / Preorders / Back issues filter becomes a quiet "All ▾" menu at the right end
   of the field; picking an option presses the matching (hidden) filter button, so the existing search behaviour is unchanged. */
try { (function () {
  function build(top, seg, before, host) {
    if (!top || !seg || top.querySelector('.cl-sflt')) return;
    var opts = [].slice.call(seg.querySelectorAll('button[role="radio"]'));
    var wrap = document.createElement('div'); wrap.className = 'cl-sflt';
    var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'cl-sflt__btn'; btn.setAttribute('aria-haspopup', 'listbox'); btn.setAttribute('aria-expanded', 'false');
    var menu = document.createElement('ul'); menu.className = 'cl-sflt__menu'; menu.setAttribute('role', 'listbox');
    opts.forEach(function (o) {
      var li = document.createElement('li'); li.setAttribute('role', 'option'); li.tabIndex = -1; li.textContent = o.textContent.trim();
      li.addEventListener('click', function (e) { e.preventDefault(); o.click(); sync(); open(false); var i = top.querySelector('input[type="search"], .search-bar__input'); if (i) i.focus(); });
      li.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); li.click(); } });
      menu.appendChild(li);
    });
    function sync() {
      var cur = opts.filter(function (o) { return o.getAttribute('aria-checked') === 'true'; })[0] || opts[0];
      btn.innerHTML = '<span>' + cur.textContent.trim() + '</span><svg viewBox="0 0 10 6" aria-hidden="true"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      wrap.classList.toggle('is-set', cur !== opts[0]);
      [].forEach.call(menu.children, function (li, i) { li.setAttribute('aria-selected', opts[i] === cur ? 'true' : 'false'); });
    }
    function open(o) { wrap.classList.toggle('is-open', o); btn.setAttribute('aria-expanded', o ? 'true' : 'false'); if (host) host.classList.toggle('cl-sflt-open', o); }
    btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); open(!wrap.classList.contains('is-open')); });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) open(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') open(false); });
    new MutationObserver(sync).observe(seg, { attributes: true, subtree: true, attributeFilter: ['aria-checked'] });
    wrap.appendChild(btn); wrap.appendChild(menu);
    top.insertBefore(wrap, before || null);
    sync();
  }
  function go() {
    [].forEach.call(document.querySelectorAll('.header .search-bar'), function (bar) { var top = bar.querySelector('.search-bar__top'); build(top, top && top.querySelector('.cl-seg'), top && top.querySelector('.search-bar__submit')); });
    /* floating bar search (desktop) */
    [].forEach.call(document.querySelectorAll('.clf__search'), function (f) { var fld = f.querySelector('.clf__field'); build(fld, f.querySelector('.cl-seg'), fld && fld.querySelector('.clf__enter'), f.closest('.clf')); });
    /* phone search drawer under the floating bar */
    [].forEach.call(document.querySelectorAll('.clf__sform'), function (f) { var fld = f.querySelector('.clf__sfield'); build(fld, f.querySelector('.cl-seg'), fld && fld.querySelector('.clf__sgo'), f.closest('.clf__sdrawer')); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})(); } catch (e) { if (window.console) console.error('[Comic Legion] a site feature failed; the rest keep working', e); }
/* "Check out FOC only" (cart page) sets the other books aside in this browser. On the next store page — after paying, or
   coming back without paying — they go back in the cart. Also runs when the browser restores a page with the Back button. */
try { (function () {
  var busy = false;
  function restore() {
    var raw; try { raw = localStorage.getItem('clAside'); } catch (e) { return; }
    if (!raw || busy) return;
    var data; try { data = JSON.parse(raw); } catch (e) { data = null; }
    try { localStorage.removeItem('clAside'); } catch (e) {}
    if (!data || !data.items || !data.items.length || Date.now() - (data.t || 0) > 30 * 864e5) return;
    busy = true;
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    /* one at a time, so a book that sold out in the meantime doesn't stop the others */
    data.items.reduce(function (p, it) {
      return p.then(function () {
        return fetch(base + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [it] }) }).catch(function () {});
      });
    }, Promise.resolve()).then(function () {
      busy = false;
      if (document.querySelector('[data-clc]') || /\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
      try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } })); } catch (e) {}
    });
  }
  restore();
  window.addEventListener('pageshow', function (e) { if (e.persisted) restore(); });
})(); } catch (e) { if (window.console) console.error('[Comic Legion] a site feature failed; the rest keep working', e); }
/* No cart popup: every cart icon (header, floating bar, phone) goes straight to the cart page. Runs before the theme's own
   click handlers, so the mini-cart drawer never opens. */
try { (function () {
  window.addEventListener('click', function (e) {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var a = e.target.closest && e.target.closest('.header__cart-toggle, .clf__cart, [data-action="toggle-mini-cart"]');
    if (!a) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var url = (window.routes && window.routes.cartUrl) || a.getAttribute('href') || '/cart';
    if (location.pathname.replace(/\/$/, '') !== url.replace(/\/$/, '')) location.href = url;
  }, true);
})(); } catch (e) { if (window.console) console.error('[Comic Legion] a site feature failed; the rest keep working', e); }
/* One line, always (owner 2026-11-03): Add to cart / "Update quantity to 12" / "3 in cart" buttons never wrap. When the words don't
   fit, the text steps down a little (to 9px at most); otherwise it keeps its normal size. Cards, the variants panel, product page. */
window.clFitBtn = function (b) {
  if (!b || !b.offsetWidth) return true;
  /* fits = the words (+ the cart icon when it shows) fit inside the button's side padding */
  function fits() {
    var cs = getComputedStyle(b), room = b.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0), r = document.createRange(), w = 0;
    [].forEach.call(b.childNodes, function (n) { if (n.nodeType === 3 && n.textContent.trim()) { r.selectNodeContents(n); w += r.getBoundingClientRect().width; } });
    var ic = getComputedStyle(b, '::before'); if (ic.content && ic.content !== 'none' && ic.display !== 'none') w += (parseFloat(ic.width) || 0) + (parseFloat(cs.columnGap) || 0);
    return w <= room + 0.5;
  }
  b.style.removeProperty('font-size'); if (fits()) return true;
  var px = parseFloat(getComputedStyle(b).fontSize) || 14;
  while (px > 9 && !fits()) { px -= 0.5; b.style.setProperty('font-size', px + 'px', 'important'); }
  return fits();
};
(function () { var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(function () {
  [].forEach.call(document.querySelectorAll('.product-item__action-button, .product-form__add-button'), window.clFitBtn); }, 200); }); })();
/* r58/r59: card quantity box (collections and homepage rows, comics). It writes into the card form's own hidden "quantity",
   so the theme's Add to cart adds that many. It matches its Add to cart button's size at every width, with the same 10px gap.
   When the book is already in the cart the box shows that quantity, and the button reads "In cart" (opens the cart),
   "Update quantity to X" (sets the cart to X) or, at 0, "Remove from cart". */
try { (function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var inCart = {};                                            /* variant id -> quantity in the cart */
  function btnOf(box) { var f = box.closest('form'); return f && f.querySelector('.product-item__action-button'); }
  function T(box, k, n) { return (box.getAttribute('data-t-' + k) || '').replace('#', n); }
  function label(box) {
    var b = btnOf(box); if (!b) return;
    if (!b.hasAttribute('data-cq-label')) b.setAttribute('data-cq-label', b.textContent.trim());
    var have = inCart[box.getAttribute('data-v')] || 0, v = parseInt(box.querySelector('[data-cq-n]').value, 10) || 0, txt, mode;
    if (!have) { txt = b.getAttribute('data-cq-label'); mode = ''; }
    else if (v === have) { txt = T(box, 'incart', have); mode = 'incart'; }
    else if (v === 0) { txt = T(box, 'remove'); mode = 'remove'; }
    else { txt = T(box, 'update', v); mode = 'update'; }
    if (b.textContent !== txt) b.textContent = txt;
    b.setAttribute('data-cq-mode', mode);
    /* very narrow cards (variants panel): if "Update quantity to 10" can't fit even small, the short "Update to 10" is used */
    if (!window.clFitBtn(b) && mode === 'update' && box.getAttribute('data-t-update-s')) { b.textContent = T(box, 'update-s', v); window.clFitBtn(b); }
    var x = box.parentElement && box.parentElement.querySelector('[data-cl-pclear="card"]');
    if (x) { x.classList.toggle('is-on', have > 0); if (have) x.removeAttribute('aria-disabled'); else x.setAttribute('aria-disabled', 'true'); }
  }
  /* the X beside the box (snippets/cl-pclear, owner 2026-11-03): takes this book out of the cart */
  document.addEventListener('click', function (e) {
    var x = e.target.closest && e.target.closest('[data-cl-pclear="card"]'); if (!x) return;
    e.preventDefault(); var id = x.getAttribute('data-v'); if (!id || !inCart[id] || x.classList.contains('is-busy')) return;
    x.classList.add('is-busy');
    fetch(root + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: id, quantity: 0 }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        inCart[id] = 0;
        [].forEach.call(document.querySelectorAll('.cl-cq[data-v="' + id + '"]'), function (b) { show(b); });
        try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } })); } catch (z) {}
      })
      .catch(function () {})
      .then(function () { x.classList.remove('is-busy'); loadCart(); });
  });
  function sync(box, v) {
    var n = box.querySelector('[data-cq-n]'), f = box.closest('form'), h = f && f.querySelector('input[type="hidden"][name="quantity"]');
    var min = inCart[box.getAttribute('data-v')] ? 0 : 1;
    v = parseInt(String(v).replace(/\D/g, ''), 10); if (isNaN(v)) v = min;
    v = Math.max(min, Math.min(999, v));
    n.value = v; if (h) h.value = Math.max(1, v); box.classList.toggle('is-min', v <= min); label(box); return v;
  }
  function show(box) { var have = inCart[box.getAttribute('data-v')] || 0; sync(box, have || 1); }
  function loadCart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      inCart = {}; (c.items || []).forEach(function (i) { inCart[i.variant_id] = (inCart[i.variant_id] || 0) + i.quantity; });
      [].forEach.call(document.querySelectorAll('.cl-cq'), function (box) { if (document.activeElement !== box.querySelector('[data-cq-n]')) show(box); });
    }).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cq]'); if (!b) return;
    e.preventDefault(); var box = b.closest('.cl-cq'), n = box.querySelector('[data-cq-n]');
    sync(box, (parseInt(n.value, 10) || 0) + (+b.getAttribute('data-cq')));
  });
  document.addEventListener('focusin', function (e) { if (e.target.matches && e.target.matches('[data-cq-n]')) e.target.select(); });
  document.addEventListener('input', function (e) { if (e.target.matches && e.target.matches('[data-cq-n]')) { var box = e.target.closest('.cl-cq'); var v = parseInt(e.target.value, 10); if (!isNaN(v)) { e.target.dataset.typed = v; } label(box); } });
  document.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('[data-cq-n]')) sync(e.target.closest('.cl-cq'), e.target.value); });
  document.addEventListener('focusout', function (e) { if (e.target.matches && e.target.matches('[data-cq-n]')) sync(e.target.closest('.cl-cq'), e.target.value); });
  /* the button: add (theme), or update / remove / open the cart when the book is already in it */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.product-item__action-button'); if (!b) return;
    var f = b.closest('form'), box = f && f.querySelector('.cl-cq'); if (!box) return;
    var v = sync(box, box.querySelector('[data-cq-n]').value), id = box.getAttribute('data-v'), have = inCart[id] || 0;
    if (!have) { [1200, 2600, 4200].forEach(function (t) { setTimeout(loadCart, t); }); return; }   /* the theme adds it (and shows "Added!", then its own wording), so the cart is read again until our label sticks */
    e.preventDefault(); e.stopImmediatePropagation();
    if (v === have) { location.href = root + 'cart'; return; }
    b.disabled = true;
    fetch(root + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: id, quantity: v }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        b.textContent = v === 0 ? T(box, 'removed') : T(box, 'updated');
        try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } })); } catch (x) {}
        setTimeout(function () { b.disabled = false; loadCart(); }, 1100);
      })
      .catch(function () { b.disabled = false; loadCart(); });
  }, true);
  document.addEventListener('submit', function (e) { var box = e.target.querySelector && e.target.querySelector('.cl-cq'); if (box) sync(box, box.querySelector('[data-cq-n]').value); }, true);
  /* size and spacing: the button's own width/height/corners, and the 10px gap the desktop cards have */
  function fit(box) {
    var a = btnOf(box); if (!a || !a.offsetHeight) return;
    var c = getComputedStyle(a), h = a.offsetHeight + 'px', mt = parseFloat(c.marginTop) || 0;
    box.style.marginTop = c.marginTop; box.style.marginLeft = c.marginLeft; box.style.marginRight = c.marginRight;
    box.style.marginBottom = Math.max(0, 10 - mt) + 'px';
    box.style.height = h; box.style.minHeight = h; box.style.maxHeight = h; box.style.borderRadius = c.borderRadius;
  }
  var ro = window.ResizeObserver ? new ResizeObserver(function () { fitSoon(); }) : null, seen = new WeakSet ? new WeakSet() : null;
  function fitAll() {
    [].forEach.call(document.querySelectorAll('.cl-cq'), function (box) {
      fit(box);
      if (seen && !seen.has(box)) { seen.add(box); show(box); }
      var a = btnOf(box); if (ro && a && !a.__clRo) { a.__clRo = 1; ro.observe(a); }
    });
  }
  var fitT; function fitSoon() { clearTimeout(fitT); fitT = setTimeout(fitAll, 60); }
  function start() { fitAll(); loadCart(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('load', fitAll); window.addEventListener('resize', fitSoon);
  window.addEventListener('pageshow', function (e) { if (e.persisted) loadCart(); });
  document.addEventListener('product:added', function () { setTimeout(loadCart, 300); });
  document.documentElement.addEventListener('cart:refresh', function () { setTimeout(loadCart, 300); });   /* e.g. the product page X */
  if (window.MutationObserver) new MutationObserver(function (ms) { for (var i = 0; i < ms.length; i++) if (ms[i].addedNodes.length) { fitSoon(); return; } }).observe(document.documentElement, { childList: true, subtree: true });
})(); } catch (e) { if (window.console) console.error('[Comic Legion] a site feature failed; the rest keep working', e); }
/* r62: product page Add to cart follows the cart, like the comic cards. When the book is already in the cart the quantity
   picker shows that number and the button reads "4 in cart" (solid gold, opens the cart), "Update quantity to X" (sets the
   cart to X) or, at 0, "Remove from cart". Wording comes from the hidden .cl-pq marker in the form (EN/FR/ES). */
try { (function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var have = 0, busy = false;
  function form() { var m = document.querySelector('form.product-form .cl-pq'); return m && m.closest('form'); }
  function parts() {
    var f = form(); if (!f) return null;
    return { f: f, m: f.querySelector('.cl-pq'), q: f.querySelector('input[name="quantity"]'), b: f.querySelector('.product-form__add-button'), id: f.querySelector('[name="id"]') };
  }
  function T(p, k, n) { return (p.m.getAttribute('data-t-' + k) || '').replace('#', n); }
  function label() {
    var p = parts(); if (!p || !p.b || !p.q || busy) return;
    /* the button's own wording ("Add to cart" / "Pre-order") is remembered once, at page load (start), never the theme's
       passing "Added!" or one of ours */
    if (!p.b.hasAttribute('data-cq-label') && !/\d/.test(p.b.textContent)) p.b.setAttribute('data-cq-label', p.b.textContent.trim());
    var v = parseInt(p.q.value, 10); if (isNaN(v)) v = 0;
    var txt, mode;
    if (!have) { txt = p.b.getAttribute('data-cq-label') || p.b.textContent.trim(); mode = ''; }
    else if (v === have) { txt = T(p, 'incart', have); mode = 'incart'; }
    else if (v === 0) { txt = T(p, 'remove'); mode = 'remove'; }
    else { txt = T(p, 'update', v); mode = 'update'; }
    if (p.b.textContent !== txt) p.b.textContent = txt;
    p.b.setAttribute('data-cq-mode', mode);
    window.clFitBtn(p.b);
    xState();
  }
  /* The X beside the quantity (snippets/cl-release-date-property): on when this book is in the cart; a click takes it out. */
  function xState() { var x = document.querySelector('form.product-form [data-cl-pclear="pp"]'); if (!x) return; x.classList.toggle('is-on', have > 0); if (have) x.removeAttribute('aria-disabled'); else x.setAttribute('aria-disabled', 'true'); }
  document.addEventListener('click', function (e) {
    var x = e.target.closest && e.target.closest('form.product-form [data-cl-pclear="pp"]'); if (!x) return;
    e.preventDefault(); var p = parts(); if (!p || !p.id || !have || busy) return;
    busy = true; x.classList.add('is-busy');
    fetch(root + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: String(p.id.value), quantity: 0 }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        have = 0; if (p.q) { p.q.min = 1; p.q.value = 1; }
        try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } })); } catch (z) {}
      })
      .catch(function () {})
      .then(function () { busy = false; x.classList.remove('is-busy'); loadCart(true); });
  });
  function loadCart(setQty) {
    var p = parts(); if (!p || !p.id) return;
    return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var id = String(p.id.value); have = 0;
      (c.items || []).forEach(function (i) { if (String(i.variant_id) === id) have += i.quantity; });
      if (p.q) {
        p.q.min = have ? 0 : 1;
        if (setQty && document.activeElement !== p.q) p.q.value = have || 1;
      }
      label();
    }).catch(function () {});
  }
  document.addEventListener('input', function (e) { if (e.target.matches && e.target.matches('form.product-form input[name="quantity"]')) label(); });
  document.addEventListener('change', function (e) {
    if (!e.target.matches) return;
    if (e.target.matches('form.product-form input[name="quantity"]')) label();
    if (e.target.matches('form.product-form [name="id"]')) loadCart(true);
  });
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('form.product-form .quantity-selector__button')) setTimeout(label, 0); });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('form.product-form .product-form__add-button'); if (!b) return;
    var p = parts(); if (!p || p.b !== b) return;
    if (!have) { [1200, 2600, 4200].forEach(function (t) { setTimeout(function () { loadCart(true); }, t); }); return; }
    e.preventDefault(); e.stopImmediatePropagation();
    var v = parseInt(p.q.value, 10); if (isNaN(v) || v < 0) v = have;
    if (v === have) { location.href = root + 'cart'; return; }
    busy = true; b.disabled = true;
    fetch(root + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: String(p.id.value), quantity: v }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        b.textContent = v === 0 ? T(p, 'removed') : T(p, 'updated');
        try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } })); } catch (x) {}
        setTimeout(function () { busy = false; b.disabled = false; loadCart(true); }, 1100);
      })
      .catch(function () { busy = false; b.disabled = false; loadCart(true); });
  }, true);
  function start() { var p = parts(); if (p && p.b && !p.b.hasAttribute('data-cq-label')) p.b.setAttribute('data-cq-label', p.b.textContent.trim()); if (form()) loadCart(true); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('pageshow', function (e) { if (e.persisted) start(); });
  document.addEventListener('product:added', function () { setTimeout(function () { loadCart(true); }, 300); });
  document.documentElement.addEventListener('cart:refresh', function () { if (!busy) setTimeout(function () { loadCart(true); }, 300); });   /* e.g. a card's X */
})(); } catch (e) { if (window.console) console.error('[Comic Legion] a site feature failed; the rest keep working', e); }
/* r66: ratio variants (owner 2026-11-01). When the cart holds enough qualifying copies of an issue (every full block of N
   from the ratio's qualifying covers, any mix, which is every regular cover of the issue, plus copies on the shopper's earlier orders), the ratio variant is added on its own, at the price set on the ratio
   (Qualified variant if there is one). Fewer qualifying copies: the extra ratio copies come off. If a shopper takes a
   ratio out, it's only added again when they reach a new block. A ratio can't be bought any other way: anything above
   what's unlocked is taken out. Only ratios whose FOC is still open count. The list comes from assets/cl-ratios.json
   (rebuilt on each FOC run). A ratio that isn't for sale yet (draft) is simply skipped. */
try { (function () {
  var url = window.clRatiosUrl; if (!url) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var map = null, busy = false, again = false, t = null, waiters = [], lastChanged = false;
  function get(k) { try { return JSON.parse(localStorage.getItem(k) || '{}') || {}; } catch (e) { return {}; } }
  function put(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function post(u, body) { return fetch(root + u, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }).then(function (r) { if (!r.ok) throw r; return r.json(); }); }
  function load() {
    if (map) return Promise.resolve(map);
    return fetch(url).then(function (r) { return r.json(); }).then(function (a) {
      var extra = []; try { extra = JSON.parse(localStorage.getItem('clRatioTest') || '[]'); } catch (e) {}   /* testing on staging only */
      map = a.concat(extra); return map;
    });
  }
  /* FOC closes at 8 PM Montreal time on the FOC date (MM/DD/YYYY) */
  function open(f) {
    var p = String(f || '').split('/'); if (p.length !== 3) return true;
    var g = Date.UTC(+p[2], +p[0] - 1, +p[1], 20, 0, 0);
    try { var q = {}; new Intl.DateTimeFormat('en-US', { timeZone: 'America/Toronto', hourCycle: 'h23', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })
      .formatToParts(new Date(g)).forEach(function (x) { q[x.type] = +x.value; }); g += g - Date.UTC(q.year, q.month - 1, q.day, q.hour, q.minute, q.second); } catch (e) { g += 5 * 36e5; }
    return Date.now() < g;
  }
  function sync(done) {
    if (typeof done === 'function') waiters.push(done);
    if (busy) { again = true; return; } busy = true; lastChanged = false;
    Promise.all([load(), fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })]).then(function (res) {
      var m = res[0], cart = res[1], bySku = {}, byVar = {}, last = get('clRatioSet'), decl = get('clRatioDecl'), ups = {}, adds = [];
      (cart.items || []).forEach(function (i) { if (i.sku) bySku[i.sku] = (bySku[i.sku] || 0) + i.quantity; byVar[i.variant_id] = (byVar[i.variant_id] || 0) + i.quantity; });
      m.forEach(function (r) {
        if (!r || !r.i || !r.n || !open(r.f)) return;
        var id = r.i, have = byVar[id] || 0;
        /* earlier orders count too (window.clRatioPrior from the theme head); ratios already received there come off */
        var prior = window.clRatioPrior || {};
        var count = (r.q || []).reduce(function (s, k) { return s + (bySku[k] || 0) + (prior[k] || 0); }, 0);
        var unlocked = Math.max(0, Math.floor(count / r.n) - (r.s ? (prior[r.s] || 0) : 0));
        if (last[id] != null && have < last[id]) decl[id] = unlocked;          /* the shopper took some out: respect it */
        var want = unlocked;
        if (decl[id] != null) { if (unlocked > decl[id]) delete decl[id]; else want = Math.min(have, unlocked); }
        if (want !== have) { if (!have) adds.push({ id: id, quantity: want, properties: { _ratio: '1:' + r.n } }); else ups[id] = want; }
        if (want > 0) last[id] = want; else delete last[id];
        if (!unlocked) delete decl[id];
      });
      var p = Promise.resolve(), changed = false;
      if (Object.keys(ups).length) p = p.then(function () { return post('cart/update.js', { updates: ups }).then(function () { changed = true; }); });
      adds.forEach(function (a) {
        p = p.then(function () { return post('cart/add.js', { items: [a] }).then(function () { changed = true; }, function () { delete last[a.id]; }); });   /* not for sale yet: skip */
      });
      return p.then(function () {
        put('clRatioSet', last); put('clRatioDecl', decl);
        lastChanged = changed;
        if (!changed) return;
        try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false, clRatio: true } })); } catch (e) {}
        if (window.clCartRefresh) window.clCartRefresh();
      });
    }).catch(function () {}).then(function () {
      busy = false;
      if (again) { again = false; sync(); return; }
      document.documentElement.classList.remove('cl-ratio-wait');
      var w = waiters; waiters = []; w.forEach(function (f) { try { f(lastChanged); } catch (e) {} });
    });
  }
  function soon() { clearTimeout(t); t = setTimeout(sync, 450); document.documentElement.classList.add('cl-ratio-wait'); }
  document.documentElement.addEventListener('cart:refresh', function (e) { if (!(e.detail && e.detail.clRatio)) soon(); });
  document.addEventListener('product:added', soon);
  window.addEventListener('pageshow', function (e) { if (e.persisted) soon(); });
  window.clRatioSync = soon;
  /* Checkout: check the ratios right now; resolves true if the cart had to be changed (then don't go to checkout yet). */
  window.clRatioCheck = function () { return new Promise(function (res) { clearTimeout(t); sync(res); setTimeout(function () { res(false); }, 8000); }); };
  /* While a cart change hasn't been checked yet, the cart page's Shop / PayPal / G Pay buttons stay locked. */
  window.clRatioHold = function () { document.documentElement.classList.add('cl-ratio-wait'); soon(); };
  document.documentElement.classList.add('cl-ratio-wait');   /* pay buttons wait for the first check */
  setTimeout(sync, 900);
})(); } catch (e) { if (window.console) console.error('[Comic Legion] a site feature failed; the rest keep working', e); }
/* r67: the "Counts toward ratio variants" line on a product page sits right under the Add to cart / Shop buttons. */
try { (function () {
  function move() {
    [].forEach.call(document.querySelectorAll('form.product-form .cl-ratio-note'), function (n) {
      var f = n.closest('form'), row = f && (f.querySelector('.product-form__payment-container') || f.querySelector('.product-form__buy-buttons'));
      if (row && n.previousElementSibling !== row) row.parentNode.insertBefore(n, row.nextSibling);
    });
  }
  /* only once this cover is in the cart */
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/', t;
  function check() {
    var ns = document.querySelectorAll('form.product-form .cl-ratio-note[data-v]'); if (!ns.length) return;
    Promise.all([fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }), ratios()]).then(function (res) {
      var c = res[0], rs = res[1], have = {}; (c.items || []).forEach(function (i) { have[i.variant_id] = 1; });
      [].forEach.call(ns, function (n) {
        /* shown when any qualifying cover of the issue is in the cart (this one or another) */
        var was = n.hidden, inc = run(n, c, rs); n.hidden = !(have[n.getAttribute('data-v')] || inc > 0);
        if (!n.hidden && was) { n.classList.remove('cl-in'); void n.offsetWidth; n.classList.add('cl-in'); }   /* soft fade when it first appears */
      });
    }).catch(function () {});
  }
  /* Running total under the note (owner, 2026-11-03): qualifying copies in the cart (+ earlier orders, which count too), and
     how many more unlock the next ratio of this issue, e.g. "4 qualifying copies in your cart. 6 more unlock a 1:10." Uses the
     same list and the same counting as the cart (assets/cl-ratios.json, window.clRatioPrior); only ratios whose FOC is open. */
  var rsP = null;
  function ratios() { if (!rsP) rsP = window.clRatiosUrl ? fetch(window.clRatiosUrl).then(function (r) { return r.json(); }).catch(function () { return []; }) : Promise.resolve([]); return rsP; }
  function focOpen(f) {
    var p = String(f || '').split('/'); if (p.length !== 3) return true;
    var g = Date.UTC(+p[2], +p[0] - 1, +p[1], 20, 0, 0);
    try { var q = {}; new Intl.DateTimeFormat('en-US', { timeZone: 'America/Toronto', hourCycle: 'h23', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })
      .formatToParts(new Date(g)).forEach(function (x) { q[x.type] = +x.value; }); g += g - Date.UTC(q.year, q.month - 1, q.day, q.hour, q.minute, q.second); } catch (e) { g += 5 * 36e5; }
    return Date.now() < g;
  }
  function run(n, c, rs) {
    var out = n.querySelector('.cl-ratio-run'), sku = n.getAttribute('data-sku'); if (!out || !sku) return 0;
    var mine = (rs || []).filter(function (r) { return r && r.n && (r.q || []).indexOf(sku) > -1 && focOpen(r.f); });
    if (!mine.length) { out.hidden = true; return 0; }
    var bySku = {}, prior = window.clRatioPrior || {}, qs = {};
    (c.items || []).forEach(function (i) { if (i.sku) bySku[i.sku] = (bySku[i.sku] || 0) + i.quantity; });
    mine.forEach(function (r) { r.q.forEach(function (k) { qs[k] = 1; }); });
    var inCart = 0, before = 0; Object.keys(qs).forEach(function (k) { inCart += bySku[k] || 0; before += prior[k] || 0; });
    var best = null;
    mine.forEach(function (r) {
      var cnt = r.q.reduce(function (s2, k) { return s2 + (bySku[k] || 0) + (prior[k] || 0); }, 0);
      var need = (Math.floor(cnt / r.n) + 1) * r.n - cnt;
      if (!best || need < best.need || (need === best.need && r.n < best.n)) best = { need: need, n: r.n };
    });
    function T(k) { return n.getAttribute('data-t-' + k) || ''; }
    var html = (inCart === 1 ? T('run1') : T('run').replace('#', inCart));
    if (before) html += ' ' + T('prior').replace('#', before);
    if (best) html += ' ' + (best.need === 1 ? T('next1') : T('next').replace('#', best.need)).replace('%', best.n);
    if (out.innerHTML !== html) out.innerHTML = html;   /* the page already shows it; only changes are written */
    out.hidden = false;
    return inCart;
  }
  function soon() { clearTimeout(t); t = setTimeout(check, 500); }
  function go() { move(); check(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
  document.addEventListener('shopify:section:load', go);
  document.documentElement.addEventListener('cart:refresh', soon);
  document.addEventListener('product:added', soon);
  window.addEventListener('pageshow', function (e) { if (e.persisted) check(); });
})(); } catch (e) { if (window.console) console.error('[Comic Legion] a site feature failed; the rest keep working', e); }

/* Foil covers (owner 2026-11-03): any book with "FOIL" in its title (not "NON-FOIL") gets a subtle foil shine on its cover,
   everywhere the cover shows: cards (collections, search, home rows, "Also on…"), the product page cover, the variants panel,
   the cart and the header quick search. A faint holographic tint plus a light sweep every few seconds, each cover on its own
   timing. Styles: snippets/cl-head-styles (.cl-foil). */
try { (function () {
  var FOIL = /(^|[^A-Z-])FOIL\b/i, NON = /NON[- ]?FOIL/i;
  function isFoil(t) { t = String(t || ''); return FOIL.test(t) && !NON.test(t); }
  /* never on banners (hero, slideshow or banner sections) */
  var BANNER = '[data-section-type="slideshow"], [id*="hero"], [class*="hero"], [id*="banner"], [class*="banner"]';
  function mark(el) { if (!el || el.classList.contains('cl-foil') || el.closest(BANNER)) return; el.classList.add('cl-foil'); el.style.setProperty('--foil-d', (-Math.random() * 12.8).toFixed(2) + 's');
    if (!el.querySelector(':scope > .cl-foil-edge')) { var e = document.createElement('span'); e.className = 'cl-foil-edge'; e.setAttribute('aria-hidden', 'true'); el.appendChild(e); }   /* the rim of light */
  }
  function wrap(img) {
    if (!img || img.closest(BANNER) || (img.parentElement && img.parentElement.classList.contains('cl-foil'))) return;
    var w = document.createElement('span'); w.className = 'cl-foil-wrap'; img.parentNode.insertBefore(w, img); w.appendChild(img); mark(w);
  }
  function scan() {
    [].forEach.call(document.querySelectorAll('.product-item'), function (c) {
      var t = c.querySelector('.product-item__title'); if (t && isFoil(t.textContent)) mark(c.querySelector('.product-item__image-wrapper .aspect-ratio') || c.querySelector('.product-item__image-wrapper'));
    });
    var h = document.querySelector('.product-meta__title');
    if (h && isFoil(h.textContent)) { var g = document.querySelector('.product-block-list__item--gallery .product-gallery__image'); if (g) { mark(g.parentElement); g.parentElement.classList.add('cl-foil--tilt'); } }
    [].forEach.call(document.querySelectorAll('.cl-covers__link'), function (a) { if (isFoil(a.getAttribute('title'))) wrap(a.querySelector('.cl-covers__img')); });
    [].forEach.call(document.querySelectorAll('.clc__img'), function (a) { var row = a.closest('[data-key]') || a.parentElement, t = row && row.querySelector('.clc__title'); if (t && isFoil(t.textContent)) mark(a); });
    [].forEach.call(document.querySelectorAll('.search-bar__result-item'), function (r) { var t = r.querySelector('.search-bar__item-title'); if (t && isFoil(t.textContent)) mark(r.querySelector('.search-bar__image-container .aspect-ratio') || r.querySelector('.search-bar__image-container')); });
  }
  /* Hover (the product page cover only): the light follows the pointer like tilting a real foil card. It is the same light as the
     loop (CSS uses --px/--py instead of the loop's --ax/--ay while .is-live), and the loop keeps running underneath. Entering:
     --px/--py start where the loop is and glide to the pointer. Leaving: they glide to where the loop will be in half a second,
     then the loop takes over again, so there is never a jump. */
  var cur = null, px = 0, py = 0, raf = 0, LOOP = 12800, GLIDE = 520;
  var KF = [[.1, .1], [.9, .9], [.9, .1], [.1, .9], [.1, .1]];              /* cl-foil-path keyframes, every 25% */
  function ease(t) { /* CSS ease-in-out, cubic-bezier(.42,0,.58,1) */
    var lo = 0, hi = 1, x, u; for (var i = 0; i < 22; i++) { u = (lo + hi) / 2; x = 3 * u * (1 - u) * (1 - u) * .42 + 3 * u * u * (1 - u) * .58 + u * u * u; if (x < t) lo = u; else hi = u; }
    u = (lo + hi) / 2; return 3 * u * u * (1 - u) + u * u * u; }
  function anim(el) { return el.getAnimations ? el.getAnimations().filter(function (a) { return a.animationName === 'cl-foil-path'; })[0] : null; }
  function pathAt(p) { p = ((p % 1) + 1) % 1; var seg = Math.min(3, Math.floor(p * 4)), k = ease(p * 4 - seg), A = KF[seg], B = KF[seg + 1]; return [A[0] + (B[0] - A[0]) * k, A[1] + (B[1] - A[1]) * k]; }
  function loopAt(el) { var an = anim(el); return pathAt(an ? (an.effect.getComputedTiming().progress || 0) : 0); }   /* where the loop's light is now */
  function setP(el, x, y, instant) {
    if (instant) el.style.setProperty('transition', 'none');
    el.style.setProperty('--px', x.toFixed(3)); el.style.setProperty('--py', y.toFixed(3));
    if (instant) { void el.offsetWidth; el.style.removeProperty('transition'); }
  }
  function apply() {
    raf = 0; if (!cur) return;
    var r = cur.getBoundingClientRect(); if (!r.width) return;
    setP(cur, Math.max(0, Math.min(1, (px - r.left) / r.width)), Math.max(0, Math.min(1, (py - r.top) / r.height)));
  }
  function move(e) {
    var el = e.target.closest && e.target.closest('.cl-foil');
    /* only the big cover on the product page reacts to the pointer; cards and panels keep their own gentle motion (owner 2026-11-03) */
    if (!el || !el.classList.contains('cl-foil--tilt')) return;
    if (e.pointerType !== 'mouse') return;   /* mouse only: phones and tablets keep the automatic loop */
    if (cur && cur !== el) leave(cur);
    if (!el.classList.contains('is-live')) { var s = loopAt(el); setP(el, s[0], s[1], true); el.classList.add('is-live'); }
    clearTimeout(el._back); var an0 = anim(el); if (an0 && an0.playState === 'paused') an0.play();   /* back in during a hand-back */
    cur = el; px = e.clientX; py = e.clientY; if (!raf) raf = setTimeout(apply, 16);
  }
  /* Leaving: the loop jumps to its moment closest to where the light is, waits there while the light makes a short glide onto
     that exact spot, then simply carries on from it (no catching up, no jump). */
  function leave(el) {
    if (cur === el) cur = null;
    if (!el.classList.contains('is-live')) return;
    var an = anim(el), x = parseFloat(el.style.getPropertyValue('--px')) || .5, y = parseFloat(el.style.getPropertyValue('--py')) || .5;
    if (!an) { el.classList.remove('is-live'); return; }
    var best = 0, bd = 9; for (var i = 0; i < 480; i++) { var q = pathAt(i / 480), dd = (q[0] - x) * (q[0] - x) + (q[1] - y) * (q[1] - y); if (dd < bd) { bd = dd; best = i / 480; } }
    var delay = an.effect.getTiming().delay || 0;
    an.currentTime = best * LOOP + delay + LOOP; an.pause();                     /* the closest frame, held */
    var t = pathAt(best); setP(el, t[0], t[1]);                                  /* the light glides onto it */
    clearTimeout(el._back); el._back = setTimeout(function () { if (cur !== el) { el.classList.remove('is-live'); an.play(); } }, GLIDE);   /* and the loop continues */
  }
  /* Owner 2026-11-03: the product page cover follows the MOUSE on computers; phones get no interaction (no motion sensors).
     Without a mouse it runs its tilting light loop on its own; everything else
     runs the light loop flat. (The hover code above is kept but switched off: set FOIL_HOVER = true to bring it back.) */
  var FOIL_HOVER = true;   /* owner 2026-11-03: mouse control back on (computers only; phones never use pointer or motion) */
  if (FOIL_HOVER) document.addEventListener('pointermove', move, { passive: true });
  if (FOIL_HOVER) document.addEventListener('pointerout', function (e) { var el = e.target.closest && e.target.closest('.cl-foil'); if (el && !el.contains(e.relatedTarget)) leave(el); }, { passive: true });
  document.addEventListener('pointercancel', function () { if (cur) leave(cur); }, { passive: true });
  document.addEventListener('pointerup', function (e) { if (e.pointerType !== 'mouse' && cur) leave(cur); }, { passive: true });
  var t; function soon() { clearTimeout(t); t = setTimeout(scan, 150); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  if (window.MutationObserver) new MutationObserver(function (ms) { for (var i = 0; i < ms.length; i++) if (ms[i].addedNodes.length) { soon(); return; } }).observe(document.documentElement, { childList: true, subtree: true });
})(); } catch (e) { if (window.console) console.error('[Comic Legion] a site feature failed; the rest keep working', e); }
